import React from 'react';
import { Row, Col } from 'antd';
import clazz from 'classnames';
import { MujiLink } from '@souche-f2e/muji';
import arrow from '@/assets/arrow.svg';
import styles from './index.module.less';
export default function TabBody(props) {
    const { tab } = props;
    return (<div className={clazz(styles['tab-nav-body'], 'tab-nav-body')}>
      <Row>
        {tab.contents.map((subTab) => (<Col span={6} key={subTab.code} className={styles['tab-nav-item']}>
            <MujiLink exact to={{ path: `/${tab.code}/${subTab.code}` }} target="_blank">
              <div>
                <p className={styles['tab-nav-item-title']}>{subTab.title}</p>

                {subTab.desc && (<p className={styles['tab-nav-item-subtitle']}>
                    {subTab.desc}
                  </p>)}
              </div>

              <div className="tab-nav-item-arrow">
                <img src={arrow} alt=""/>
              </div>
            </MujiLink>
          </Col>))}
      </Row>
    </div>);
}
